"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHydrated = useHydrated;
const react_1 = require("react");
function useHydrated() {
    const [hydrated, setHydrated] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => setHydrated(true), []);
    return hydrated;
}
